import { useEffect, useState } from 'react';

// VYERA Symbol — uses public/vyera.svg with rhythm animation (paths pulsing in sequence)
type Props = { className?: string; animated?: boolean };

const VYERA_SVG_URL = '/vyera.svg';

export const VFrequencyMark = ({ className = '', animated = true }: Props) => {
  const [rawSvg, setRawSvg] = useState<string | null>(null);

  useEffect(() => {
    fetch(VYERA_SVG_URL)
      .then((r) => r.text())
      .then((html) => {
        setRawSvg(html.replace(/fill="#000000"/g, 'fill="currentColor"'));
      })
      .catch(() => setRawSvg(null));
  }, []);

  if (!animated) {
    return <img src={VYERA_SVG_URL} alt="VYERA" className={className} />;
  }

  if (!rawSvg) {
    return (
      <img
        src={VYERA_SVG_URL}
        alt="VYERA"
        className={className}
        aria-hidden
      />
    );
  }

  const svgWithClass = rawSvg.replace(
    /<svg\s/,
    '<svg class="vyera-symbol-rhythm ' + className.replace(/"/g, '') + '" '
  );

  return (
    <span
      className={`inline-block ${className}`}
      style={{ display: 'block' }}
      dangerouslySetInnerHTML={{ __html: svgWithClass }}
      aria-hidden
    />
  );
};

export default VFrequencyMark;
